module.exports = require("./../../_gen/motion/easing/Linear");